import {doc, addDoc, getDoc, collection, setDoc, serverTimestamp} from "firebase/firestore";
import {ref, uploadString, getDownloadURL} from "firebase/storage";

import {getFirebase} from "../config/firebase.config";

const collectionName = "evvRequests";
const {firestore, storage} = getFirebase();
const collectionRef = collection(firestore, collectionName);

const getAll = () => {
    return collectionRef;
};
const getDocById = (docId) => {
    return getDoc(doc(firestore, collectionName, docId));
}
const set = (docId, data) => {
    const docRef = doc(firestore, collectionName, docId);
    data.createdAt = serverTimestamp();
    return setDoc(docRef, data, {merge: true});
};
const create = (data) => {
    data.createdAt = serverTimestamp();
    return addDoc(collectionRef, data)
};
const update = (id, value) => {
    return collectionRef.doc(id).update(value);
};
const remove = (id) => {
    return collectionRef.doc(id).delete();
};

const uploadSignature = (evvId, file) => {
    const storageRef = ref(storage, `signatures/${evvId}.png`);
    return uploadString(storageRef, file.split(/,(.+)/)[1], 'base64', {contentType: "image/png"});
}

const getFileUrl = (fileRef) => {
    return getDownloadURL(fileRef);
}

const EvvService = {
    getAll,
    getDocById,
    set,
    create,
    update,
    remove,
    uploadSignature,
    getFileUrl
}
export default EvvService;

